class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;

        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            // Fetch fresh cart content before opening
            this.fetchCartContent().then(() => {
                this.open(cartLink);
            });
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                // Fetch fresh cart content before opening
                this.fetchCartContent().then(() => {
                    this.open(cartLink);
                });
            }
        });
    }

    fetchCartContent() {
        return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then((response) => response.json())
            .then((data) => {
                // Update cart drawer content
                this.getSectionsToRender().forEach((section) => {
                    const sectionElement = section.selector
                        ? document.querySelector(section.selector)
                        : document.getElementById(section.id);

                    if (!sectionElement) return;

                    const sectionHTML = data[section.id];
                    if (!sectionHTML) return;

                    const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
                    if (innerHTML) {
                        sectionElement.innerHTML = innerHTML;
                    }
                });

                // Update cart count from cart.js
                return fetch('/cart.js')
                    .then(response => response.json())
                    .then(cartData => {
                        if (cartData.item_count !== undefined) {
                            const cartCountNumber = document.querySelector('#cart-count-bubble .cart-count-number');
                            if (cartCountNumber) {
                                cartCountNumber.textContent = cartData.item_count;
                            }
                        }
                    });
            })
            .catch((error) => {
                console.error('Error fetching cart content:', error);
            });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

        // Scroll cart contents to top
        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
            cartDrawerItems.scrollTop = 0;
        }

        // Scroll drawer inner to top as well
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) {
            drawerInner.scrollTop = 0;
        }

        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            {once: true}
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;

            const sectionHTML = parsedState.sections[section.id];
            if (!sectionHTML) return;

            const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
            if (innerHTML) {
                sectionElement.innerHTML = innerHTML;
            }
        });

        // Update cart count bubble immediately
        if (parsedState.item_count !== undefined) {
            const cartCountBubble = document.querySelector('#cart-count-bubble .cart-count-number');
            if (cartCountBubble) {
                cartCountBubble.textContent = parsedState.item_count;
            }
        }

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

            // Scroll to top before opening
            const cartDrawerItems = this.querySelector('cart-drawer-items');
            if (cartDrawerItems) {
                cartDrawerItems.scrollTop = 0;
            }

            const drawerInner = this.querySelector('.drawer__inner');
            if (drawerInner) {
                drawerInner.scrollTop = 0;
            }

            this.open();
        }, 50);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        if (!html) return '';
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const element = parsed.querySelector(selector);
        return element ? element.innerHTML : '';
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);
